import { isMobileOnly } from 'react-device-detect';

export const useStyles = () => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      columnGap: 1,
    },
    text: {
      fontWeight: 'inherit',
      fontSize: isMobileOnly ? 14 : 16,
      lineHeight: 1,
      textTransform: 'capitalize',
    },
  };
};
